import { gsap } from "gsap";
import { CSSRulePlugin } from "gsap/CSSRulePlugin";
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(SplitText, CSSRulePlugin, ScrollTrigger, ScrollToPlugin);
export default class Hero {
    constructor(el) {
        this.el = el;
        this.setVars();
        this.init();
    }

    setVars() {
        // heading, copy, logo, nav
        this.heading = this.el.querySelector("[data-heading]");
        this.copy = this.el.querySelector("[data-copy]");
        this.logo = this.el.querySelector("[data-logo]");
        this.nav = this.el.querySelector("[data-nav]");
        this.links = this.nav.querySelectorAll("a");
        this.startMessage = this.el.querySelector('[data-initial-message]');
        this.quote = this.el.querySelector('[data-quote]');
        this.splitHeading = new SplitText(this.heading, { type: "words" });
        this.imageContainer = this.el.querySelector('[data-image-container]');
        this.pin = document.querySelector('[data-pin]');
        this.screen = this.el.querySelector('[data-screen]');
    }

    init() {
        this.handleScreenScroll();
    }

    handleHide(elem) {
        gsap.set(elem, {autoAlpha: 0})
        elem.classList.remove('hidden');
    }

    // handles darkening and fading out text as user scrolls
    handleScreenScroll = () => {

        //
        // Animate items in
        //
        gsap.set([this.logo, this.copy, this.links], {
            autoAlpha: 0,
        });
        const tl = gsap.timeline({
            duration: 0.2,
            onComplete: enableScroll
        });

        tl.to(this.logo, {
                autoAlpha: 1,
            })
            .fromTo(
                this.splitHeading.words,
                { autoAlpha: 0, y: -15 },
                { autoAlpha: 1, y: 0, stagger: 0.1, duration: 0.8 }, '-=0.4'
            )

            .fromTo(
                this.copy,
                {
                    autoAlpha: 0,
                    y: -15,
                },
                {
                    autoAlpha: 1,
                    y: 0,
                },
                "-=0.45",
            )
            .fromTo(
                this.links,
                {
                    autoAlpha: 0,
                    y: -15,
                },
                {
                    autoAlpha: 1,
                    y: 0,
                },
                "-=0.4",
            );
        let scrollTimeline = gsap.timeline({paused: true});
        scrollTimeline.to(
            [this.splitHeading.words,  this.copy],{
                y: -20,
                autoAlpha: 0,
                stagger: 0.1,
            }, 0
        );
        scrollTimeline.call(() => {
            if(scrollTimeline.scrollTrigger.direction > 0) {
                this.startMessage.classList.add('hidden');
                this.quote.classList.remove('hidden');
            }
            // backwards
            else {
                this.startMessage.classList.remove('hidden');
                this.quote.classList.add('hidden');
            }
        });
        scrollTimeline.fromTo(
            this.quote,{ autoAlpha: 0,y:20},{
                y: 0,
                autoAlpha: 1,
                stagger: 0.1,
            }
        )
        scrollTimeline.fromTo(
            this.quote,
            {
              y: 0,
              autoAlpha: 1
            },
            {
                y: -20,
                autoAlpha: 0,
                stagger: 0.1,
                duration: 1,
            }
        )

        scrollTimeline.to(this.screen, {
            opacity: 1,
            duration: 2
        }, 0)



        let trigger = this.el;
        function enableScroll() {
            ScrollTrigger.create({
                trigger: trigger,
                start: "top top",
                end: "bottom top",
                pin:true,
                animation:scrollTimeline,
                toggleActions: "pause pause resume reset",
                scrub:0.8
            })
        }
    };
}
